//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_VALIDACIONES = "obtenerValidaciones";
export const OBTENER_VALIDACIONES_POR_RESPUESTA = "obtenerValidacionesPorvalidacion;"
export const OBTENER_VALIDACION = "obtenerValidacion";
export const REGISTRAR_VALIDACION = "registrarValidacion";
export const ACTUALIZAR_VALIDACION = "actualizarValidacion";



export const REGISTRAR_VALIDACION_RESPUESTA = "registrarValidacionRespuesta";
export const ACTUALIZAR_ESTADO_VALIDACION_RESPUESTA = "actualizarEstadoValidacionRespuesta";

// mutation types
export const SET_VALIDACIONES = "setValidaciones";
export const SET_VALIDACION = "setValidacion";

const state = {
    validaciones:[],
    validacion:[],
    data: [
        {id:1, nombreValidacion: 'Números entre', valorDefinido: '1 y 10', respuestasIdValorSeleccionado: null, estadosId: 1, estado: 'Activo', indicesId: 1, respuestasId: 1}, 
        {id:2, nombreValidacion: 'Fecha entre', valorDefinido: '01/01/2019 y 02/02/2021', respuestasIdValorSeleccionado: null, estadosId: 2, estado: 'Inactivo', indicesId: 1, respuestasId: 2},
        {id:3, nombreValidacion: 'Número Mayor que', valorDefinido: '0', estadosId: 1, respuestasIdValorSeleccionado: 1, estado: 'Activo', indicesId: 1, respuestasId: 1},
        {id:4, nombreValidacion: 'Número Menor que', valorDefinido: '10', estadosId: 1, respuestasIdValorSeleccionado: null, estado: 'Activo', indicesId: 1, respuestasId: 2},
        {id:5, nombreValidacion: 'Fecha Posterior que', valorDefinido: '15/01/2020', respuestasIdValorSeleccionado: null, estadosId: 1, estado: 'Activo', indicesId: 1, respuestasId: 2},
        {id:6, nombreValidacion: 'Fecha Anterior que', valorDefinido: '01/01/2019', respuestasIdValorSeleccionado: null, estadosId: 2, estado: 'Inactivo', indicesId: 1, respuestasId: 2},
        
        
    ],

    
}

const getters = {
    obtenerValidaciones(state) {
      return state.validaciones;
    },
}

const actions = {
    async [OBTENER_VALIDACIONES](context, estadoId) {
        let endpoint = `api/Validaciones`;
        if(estadoId!=0){
            endpoint = `api/Validaciones/Estado/${estadoId}`
        }
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_VALIDACIONES, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },

    

    async [OBTENER_VALIDACION](context, id){
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/validaciones/`)
                .then(({ data }) => {
                    context.commit(SET_VALIDACION,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [REGISTRAR_VALIDACION](context, datosIndice){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Indice`, datosIndice)
                .then(({ data }) => {
                    context.commit(SET_VALIDACION, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [ACTUALIZAR_VALIDACION](context, datosIndice){
        let id = datosIndice.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Indice/`, datosIndice)
                .then(({ data }) => {
                    context.commit(SET_VALIDACION, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    /**
     * Obtener Listado de validaciones por pregunta seleccionada
     * @param {*} context 
     * @param {*} indiceId 
     */
     async [OBTENER_VALIDACIONES_POR_RESPUESTA](context, datos){
        
        /*
        * Si el estado es 0 va a traer a todos los listas, de lo contrario va a traer los listas por estado
        *
        */
           let endpoint = `api/RespuestaValidacion/all/${datos.respuestasId}`
           if(datos.estadoId>0){
               endpoint = `api/RespuestaValidacion/Estado/${datos.estadoId}/${datos.respuestasId}`
           }
   
           return new Promise(resolve => {
               ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                   .then(({ data }) => {
                       context.commit(SET_VALIDACIONES, data.data);
                       resolve(data)
                   })
                   .catch((error) => {
                       resolve(error)
                       //context.commit(SET_ERROR, response.data.errors);
                   });
           }); 
    },

    /**
     * Registrar validacion para una respuesta
     * @param {*} context 
     * @param {*} datosValidacion 
     * @returns 
     */

    async [REGISTRAR_VALIDACION_RESPUESTA](context, datosValidacion){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/RespuestaValidacion/${datosValidacion.tipoValorInicial}/${datosValidacion.tipoValorFinal}`, datosValidacion.datosItem)
                .then(({ data }) => {
                    context.commit(SET_VALIDACION, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    /**
     * Cambiar el estado de validacion
     * @param {*} context 
     * @param {*} Id 
     * @returns 
     */

    async [ACTUALIZAR_ESTADO_VALIDACION_RESPUESTA](context, datos){
        return new Promise(resolve => {
            //console.log(datos)
            let Id = datos.id;

            ApiService.post(`apiconsume/update/${datos.id}?endpoint=api/RespuestaValidacion/ActualizarEstado/`, datos)
                .then(({ data }) => {
                    context.commit(SET_VALIDACION, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }

}

const mutations = {
    [SET_VALIDACIONES](state, data) {
        state.validaciones = data;
    },

    [SET_VALIDACION](state, data) {
        state.validacion = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}